// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.blog {
    padding: 3rem 2rem;
    background: #f9f9f9;
}

.blog article {
    text-align: center;
    margin-bottom: 2rem;
}

.blog article h3 {
    color: #1e3a8a;
    font-size: 1.5rem;
}

.blog article p {
    margin: 0.5rem 0;
}

.blog article a {
    color: #ffd700;
    text-decoration: none;
    font-weight: bold;
}

.blog article a:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/blog/blog.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".blog {\n    padding: 3rem 2rem;\n    background: #f9f9f9;\n}\n\n.blog article {\n    text-align: center;\n    margin-bottom: 2rem;\n}\n\n.blog article h3 {\n    color: #1e3a8a;\n    font-size: 1.5rem;\n}\n\n.blog article p {\n    margin: 0.5rem 0;\n}\n\n.blog article a {\n    color: #ffd700;\n    text-decoration: none;\n    font-weight: bold;\n}\n\n.blog article a:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
